export default __webpack_public_path__ + "static/media/pollutionInAsia.3e4c252d.webp";